<template>
  <div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>Meu Perfil</h4>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="perfil">
        <div class="card" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4" >
                      <p>Nome: {{perfil.nome}}</p>
                      <p>Email: {{perfil.email}}</p>
                      <p v-if="perfil.departamento">Departamento: {{perfil.departamento}}</p>
                  </div>
                </div>
            </div>  
        </div> 
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/assuntoSecretariaController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      perfil:{
         nome:null,
         email:null,
         tipo:null,
         departamento:null,
      },
      user: {
        admin: null,
        admin_sistema: null,
      },
      array:[]
    };
  },
  methods: {
    async meuPerfil(){
       try {
         let me = await this.$me();
         this.perfil.nome = me.name;
         this.perfil.email = me.email;

         if(me.cidadao ==0 && me.admin ==0){
           this.perfil.tipo = "Administrador";
         }else if(me.cidadao ==0 && me.admin ==1){
           this.perfil.tipo = "Super Administrador";
         }
        //this.perfil.departamento = me.departamento;

        let s = await this.$secretariaAvan();

        //console.log(this.perfil.departamento);
        s.data.forEach(element => {
          console.log(element.secretaria);
          if(element.id == me.departamento){
            this.perfil.departamento = element.secretaria;
          }
        });

       } catch (e) {
         
       }
    }
  },
  beforeMount() {
    try {
      this.meuPerfil();
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
    } catch (e) {}
  },
};
</script>

